module.exports = __webpack_public_path__ + "img/vuexy-logo.d76e4687.png";